import { specials } from "@/mocks/homeData";

export default function Specials() {
  return (
    <section id="specials" className="border-y border-ink/10 bg-ink text-cream">
      <div className="shell-wrap py-14 md:py-20">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="inline-flex items-center gap-2 font-sans text-xs md:text-sm font-bold tracking-wider uppercase text-ember">
              <i className="ri-stack-fill" /> 专题研究
            </p>
            <h2 className="title-serif mt-2 text-2xl font-black text-cream md:text-4xl">
              跨对象、跨时间的纵深整理
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-cream/60">
            跳出单条瓜，把行业、现象与方法论放进同一标尺反复比对，一次看懂一个话题的底层逻辑。
          </p>
        </div>

        <div className="mt-8 divide-y divide-cream/10 rounded-2xl border border-cream/10">
          {specials.map((s, i) => (
            <article
              key={s.title}
              className="group grid cursor-pointer gap-4 p-5 transition-colors hover:bg-cream/[0.04] md:grid-cols-[100px_1fr_auto] md:items-center md:p-6"
            >
              <div>
                <p className="text-5xl font-black text-ember/70 md:text-6xl">
                  {String(i + 1).padStart(2, "0")}
                </p>
                <span className="mt-2 inline-block rounded-md bg-ember px-2 py-0.5 text-[11px] font-bold text-white">
                  {s.key}
                </span>
              </div>
              <div>
                <h3 className="title-serif text-lg font-black text-cream md:text-2xl">{s.title}</h3>
                <p className="mt-2 max-w-2xl text-sm leading-relaxed text-cream/65">{s.summary}</p>
                <p className="mt-2 text-xs text-cream/45">{s.meta}</p>
              </div>
              <span className="hidden h-10 w-10 items-center justify-center rounded-full border border-cream/20 text-cream transition-all group-hover:border-ember group-hover:bg-ember group-hover:text-white md:flex">
                <i className="ri-arrow-right-up-line" />
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}